"use strict";

(function () {
  'use strict';

  function TripsDetailCtrl($stateParams, $state, $uibModal, TripService, Moment, LRNotification, UtilsService, ConnectionsService, $timeout, DateService) {
    var vm = this;
    vm.initial = true;
    vm.loading = true;
    this.showBalanceDueAlert = false;

    var _loadTrip = function _loadTrip(callback) {
      TripService.getDetails($stateParams.adminCustDataId, $stateParams.transactionId).then(function (response) {
        vm.detail = angular.copy(response);
        $timeout(function () {
          vm.initial = false;
        }, 1000);
        vm.loading = false; // check if this transaction is allowed to have updates and payments

        vm.readOnly = vm.detail.pendingProcess && vm.detail.payments && vm.detail.payments.length && vm.detail.payments[0].processStatus === 'PENDING';
        vm.showBalanceDueAlert = false;
        vm.showSensitiveInfo = false;
        vm.showSensitiveDate = null;

        if (new Date(response.endDate) >= new Date() && !response.cancelDate) {
          vm.availableOptions = TripService.helpers.getAvailableOptions(vm.detail);
        }

        try {
          var dueDate = Moment(response.balanceDueDate).startOf('day');
          var today = Moment().startOf('day');

          if (dueDate.diff(today, 'days', true) <= 0 && parseFloat(response.balanceDue).toFixed(2) > 0 && response.processStatus === 'APPROVED' && !response.cancelDate) {
            vm.showBalanceDueAlert = parseFloat(response.balanceDue).toFixed(2) && !vm.readOnly;
          }

          var showSensitiveStart = Moment(DateService.formatSlashesToDashes(response.startDate)).subtract(1, 'day').startOf('day');
          var showSensitiveEnd = Moment(DateService.formatSlashesToDashes(response.endDate)).add(1, 'day').endOf('day');

          if (today.diff(showSensitiveStart) > 0 && showSensitiveEnd.diff(today) > 0) {
            vm.showSensitiveInfo = true;
          } else if (today.diff(showSensitiveStart) < 0) {
            vm.showSensitiveDate = showSensitiveStart.format();
          }
        } catch (error) {
          console.log(error);
        }

        if (typeof callback === 'function') {
          callback();
        }
      }, function (error) {
        //console.log(error);
        vm.initial = false;
        vm.loading = false;
        LRNotification.error('Error loading trip');
        $state.go('trips.list');

        if (typeof callback === 'function') {
          callback();
        }
      });
    };

    this.showAllOptions = function (id) {
      this.openOptionsModal(vm.detail, id || null);
    };

    this.openOptionsModal = function (_transaction, optionId) {
      var _startingBalance = parseFloat(_transaction.totalBalance).toFixed(2);

      function OptionsModalCtrl(transaction, option, $uibModalInstance) {
        this.transaction = transaction;
        this.option = option;
        this.close = $uibModalInstance.close;
        this.dismiss = $uibModalInstance.dismiss;
      }

      OptionsModalCtrl.$inject = ['transaction', 'option', '$uibModalInstance'];
      $uibModal.open({
        template: '<options-modal transaction="$ctrl.transaction" option="$ctrl.option" close="$ctrl.close($event)" dismiss="$ctrl.dismiss($event)"/>',
        controllerAs: '$ctrl',
        animation: false,
        keyboard: false,
        backdrop: 'static',
        controller: OptionsModalCtrl,
        size: 'lg',
        resolve: {
          transaction: function transaction() {
            return angular.copy(_transaction);
          },
          option: function option() {
            return optionId;
          }
        }
      }).result.then(function (modalObj) {
        vm.loading = 'options';
        TripService.updateTrip(modalObj).then(function (result) {
          var _balanceDue = parseFloat(result.balanceDue).toFixed(2);

          var _totalBalance = parseFloat(result.totalBalance).toFixed(2);

          var difference = _totalBalance - _startingBalance;

          _loadTrip(function () {
            if (vm.detail.processStatus === 'APPROVED' && _balanceDue > 0) {
              vm.addPayment(difference);
            }
          });
        }, function (error) {
          console.log(error);
          vm.loading = false;
        });
      }, function (reason) {
        console.log('cancelled', reason);
      });
    };

    this.openPaymentModal = function (_adminCustDataId, _transactionId, _amount, _balanceDue2, _balanceDueDate, billingInfo, _creditCard, _currencySymbol) {
      function PaymentModal(adminCustDataId, transactionId, amount, balanceDue, balanceDueDate, billing, creditCard, currencySymbol, $uibModalInstance) {
        this.adminCustDataId = adminCustDataId;
        this.transactionId = transactionId;
        this.amount = amount;
        this.balanceDue = balanceDue;
        this.balanceDueDate = balanceDueDate;
        this.billing = billing;
        this.creditCard = creditCard;
        this.currencySymbol = currencySymbol;
        this.close = $uibModalInstance.close;
        this.dismiss = $uibModalInstance.dismiss;
      }

      PaymentModal.$inject = ['adminCustDataId', 'transactionId', 'amount', 'balanceDue', 'balanceDueDate', 'billing', 'creditCard', 'currencySymbol', '$uibModalInstance'];
      $uibModal.open({
        template: '<payment-modal ' + 'amount="{{$ctrl.amount}}" ' + 'balance-due="{{$ctrl.balanceDue}}" ' + 'balance-due-date="{{$ctrl.balanceDueDate}}" ' + 'amount="{{$ctrl.amount}}" ' + 'admin="{{$ctrl.adminCustDataId}}" ' + 'transaction="{{$ctrl.transactionId}}" ' + 'billing="$ctrl.billing" ' + 'credit-card="$ctrl.creditCard" ' + 'currency-symbol="{{$ctrl.currencySymbol}}" ' + 'close="$ctrl.close($event)" ' + 'dismiss="$ctrl.dismiss($event)"/>',
        controllerAs: '$ctrl',
        animation: false,
        keyboard: false,
        backdrop: 'static',
        controller: PaymentModal,
        resolve: {
          adminCustDataId: function adminCustDataId() {
            return _adminCustDataId;
          },
          transactionId: function transactionId() {
            return _transactionId;
          },
          amount: function amount() {
            return _amount;
          },
          balanceDue: function balanceDue() {
            return _balanceDue2;
          },
          balanceDueDate: function balanceDueDate() {
            return _balanceDueDate;
          },
          billing: function billing() {
            return angular.copy(billingInfo);
          },
          creditCard: function creditCard() {
            return angular.copy(_creditCard);
          },
          currencySymbol: function currencySymbol() {
            return _currencySymbol;
          }
        }
      }).result.then(function (result) {
        vm.loading = 'payment';
        var _paymentStatus = {
          APPROVED: 'Payment Added Successfully',
          DECLINED: 'Payment was not accepted. Please check card information and try again.',
          Error: 'There was an error making payment. Please try again.'
        };

        if (result === 'APPROVED') {
          LRNotification.success(_paymentStatus[result], 3500);
        } else {
          LRNotification.error(_paymentStatus[result], 3500);
        }

        _loadTrip();
      }, function (reason) {
        console.log('cancelled', reason);
      });
    };

    this.addPayment = function (amount) {
      vm.openPaymentModal(vm.detail.adminCustDataID, vm.detail.transactionID, amount || 0, vm.detail.balanceDue, vm.detail.balanceDueDate, vm.detail.billingDTO, vm.detail.creditCardDTO, vm.detail.currencyInfo.Symbol);
    };

    this.$onInit = function () {
      if (UtilsService.isNumber($stateParams.adminCustDataId) && UtilsService.isNumber($stateParams.transactionId)) {
        ConnectionsService.checkSingleApproved($stateParams.adminCustDataId).then(function (data) {
          if (data.dateApproved) {
            _loadTrip();
          } else {
            ConnectionsService.openApprovalModal(data).then(function (result) {
              ConnectionsService.approve(data.adminCustDataId).then(function () {
                _loadTrip();
              }, function (error) {
                LRNotification.error('Error Connecting with Manager, Please Try Again.');
                $state.go('account.relationships');
              });
            }, function (reason) {
              LRNotification.error('Must connect with manager before you can view this Trip');
              $state.go('account.relationships');
            });
          }
        }, function () {
          vm.initial = false;
          vm.loading = false;
          LRNotification.error('Error loading trip');
          $state.go('trips.list');
        });
      } else {
        //console.log(error);
        vm.initial = false;
        vm.loading = false;
        LRNotification.error('Error loading trip');
        $state.go('trips.list');
      }
    };
  }

  TripsDetailCtrl.$inject = ['$stateParams', '$state', '$uibModal', 'TripService', 'Moment', 'LRNotification', 'UtilsService', 'ConnectionsService', '$timeout', 'DateService'];
  angular.module('view.trips').component('tripsDetail', {
    bindings: {},
    controller: TripsDetailCtrl,
    templateUrl: 'views/trips/trips-detail/trips-detail.html'
  });
})();